/**
 * Copyright © Amazon.com and Affiliates: This deliverable is considered Developed Content as defined in the AWS Service Terms 
 * and the SOW between the parties dated 10/31/2024.
 */
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { USER_ID_DEV } from '../../../mock/user';
import { Content } from '../admin/content.service';
import { TokenPropertyService } from '../token-property.service';


export type ReportResponse = {
  activeProducts: string[];
  report_list: Content[];
}
@Injectable({
  providedIn: 'root'
})

export class ReportsService {
  private API_URL: string;
  private token: any;
  private tokenDetails: any;
  private userId: string = USER_ID_DEV;
  private idToken: any;

  constructor(
    private http: HttpClient,
    @Inject('API_URL') apiUrl: string,
    private tokenPropertyService: TokenPropertyService
  ) {
    this.API_URL = apiUrl;
    this.token = localStorage.getItem('token');
    this.idToken = localStorage.getItem('id_token');
    this.userId = this.tokenPropertyService.getPropertyFromToken('sub', 'token') || USER_ID_DEV;
  }
  // Get User Reports & Dashboards
  getReports(): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    return this.http.get<any>(`${this.API_URL}/user/reports?userId=${this.userId}`, { headers })
  }

  // Share a report
  shareReport(contentId: string, dashboardId: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    const body = {
      contentId: contentId,
      dashboardId: dashboardId
    };
    return this.http.post<any>(`${this.API_URL}/user/reports/shared`, body, { headers });
  }
}
